import { useCallback } from 'react';
import axios, { useApiRequest } from './axios';

const TENANTS_URL = '/tenants/';
const DEACTIVATE_TENANT_URL = '/deactivate-tenant/';
const REACTIVATE_TENANT_URL = '/reactivate-tenant/';
// Registering builds the workspace's database schema and runs every migration
// on it, which takes well past the default request timeout. Giving up early
// doesn't stop the server, so the workspace would get created while the form
// reports a failure. Stays under Cloudflare's 100 s (gunicorn allows 120 s).
const REGISTRATION_TIMEOUT = 90000;

export const useTenantsRequests = () => {
  const { loading, error, executeRequest } = useApiRequest();

  const create = useCallback(async (data: any): Promise<any | undefined> => {
    return await executeRequest(() =>
      axios.post(TENANTS_URL, { ...data }, { timeout: REGISTRATION_TIMEOUT })
    );
  }, [executeRequest]);

  const updateFormData = useCallback(async (data: any): Promise<any | undefined> => {
    const { id, ...rest } = data;
    const formData = new FormData();
    Object.entries(rest).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value as any);
      }
    });

    return await executeRequest(() =>
      axios.patch(`${TENANTS_URL}${id}/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );
  }, [executeRequest]);

  const deactivate = useCallback(async (): Promise<any | undefined> => {
    return await executeRequest(() => axios.get(DEACTIVATE_TENANT_URL));
  }, [executeRequest]);

  const reactivate = useCallback(async (): Promise<any | undefined> => {
    return await executeRequest(() => axios.get(REACTIVATE_TENANT_URL));
  }, [executeRequest]);

  return { loading, error, create, updateFormData, deactivate, reactivate };
};
